import ReactDOM from 'react-dom';
import ApolloProvider from './ApolloProvider';
import './index.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(ApolloProvider, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workerzs: https:s//bit.ly/CRA-PWA
serviceWorker.unregister();
